export default "__VITE_ASSET__P1FH7Ql5__"